<template>
  <div class="home-wrap">
    <div class="padding-12-15 padding-b-30">
      <div class="title-text">推广位报表</div>
      <div class="search-wrap">
        <div class="form-item">
          <el-select v-model="searchForm.app_key" placeholder="全部推广位" style="width: 165px;">
            <el-option v-for="item in appList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.start_time" @blur.native @focus="showDatePicker('startTime')"  placeholder="下单日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.start_time" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.start_time')">
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.end_time" @blur.native @focus="showDatePicker('endTime')" placeholder="下单日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.end_time" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.end_time')">
            </el-col>
          </div>
          <van-popup v-model="isPopShow" position="bottom" round>
            <van-datetime-picker
              v-model="startTime"
              type="date"
              :max-date="currentTime"
              :formatter="formatter"
              :visible-item-count="5"
              v-if="datePicker == 'startTime'"
              title='请选择开始时间'
              @cancel="cancelPicker"
              @confirm="confirmPicker"
              show-toolbar
            />
            <van-datetime-picker
              v-model="endTime"
              type="date"
              :min-date="startTime"
              :max-date="currentTime"
              :formatter="formatter"
              :visible-item-count="5"
              v-if="datePicker == 'endTime'"
              title='请选择结束时间'
              @cancel="cancelPicker"
              @confirm="confirmPicker"
              show-toolbar
            />
          </van-popup>
        </div>
        <div class="search-box">
          <span class="search-btn" @click="appMovieDayStatistics">查询</span>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-8">
      <!-- <div class="title-text">近30日数据趋势</div> -->
      <div class="echart-content">
        <div class="echart-dom" id="chartLineBox"></div>
        <div class="echar-desc">
          <div class="detail-item">
            <span class="detail-badge bg-orange"></span>
            <span class="detail-title">点击数:</span>
            <span class="detail-content">{{clickNum}}</span>
          </div>
          <div class="detail-item">
            <span class="detail-badge bg-blue"></span>
            <span class="detail-title">预估订单量:</span>
            <span class="detail-content">{{validOrderNum}}</span>
          </div>
          <div class="detail-item">
            <span class="detail-badge bg-pink"></span>
            <span class="detail-title">预估收入:</span>
            <span class="detail-content">{{validIncome}}</span>
          </div>
        </div>
        <div class="echart-info">
          <p class="font-15">报表说明：</p>
          <p>1.订单数、订单金额、预估佣金更新都可能有延迟，延迟时间在10分钟左右。</p>
          <p>2.本报表显示在指定的时间段内发生的订单状况。</p>
          <p>3.本报表显示的数据非最终确认结算的数据。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import { getDate } from '@/utils/date'
  import { index,appMovieDayStatistics } from '@/api/promotion'
  export default {
    name: 'PromotionReport',
    components: {
      echarts
    },
    data () {
      return {
        isAjaxRequest: false,
        appList: [],
        dayList:[],
        clickNum:0,
        validIncome:0,
        validOrderNum:0,
        clickNumList:[],
        validIncomeList:[],
        validOrderNumList:[],
        listLoading: false,
        searchForm: {
          page: 1,
          pagesize: 10,
          app_key: undefined,
          start_time: undefined,
          end_time: undefined,
          sort: '-id'
        },
        currentTime: new Date(), // 开始时间不能超过当前时间
        startTime: new Date(), // 开始时间
        endTime: new Date(), // 结束时间
        datePicker: '', // 用于判断哪个选择器的显示与隐藏
        isPopShow: false, // 弹出层隐藏与显示
      }
    },
    created(){
      this.$nextTick(() => {
        this.appMovieDayStatistics(true)
      })
    },
    mounted: function () {
    },
    methods: {
      appMovieDayStatistics(){
        const app_key = this.$route.query.app_key
        if (app_key && !this.searchForm.app_key){
          this.searchForm.app_key = parseInt(app_key)
        }
        let searchForm = Object.assign({}, this.searchForm)
        appMovieDayStatistics(searchForm).then(response => {
          this.appList = response.data.appList
          this.dayList = response.data.dayList

          if(this.dayList.length == 0){
            this.dayList = ['暂无数据']
          }
          this.clickNum = response.data.clickNum
          this.validIncome = response.data.validIncome
          this.validOrderNum = response.data.validOrderNum
          this.clickNumList = response.data.clickNumList
          if(this.clickNumList.length == 0){
            this.clickNumList= [0];
          }
          this.validIncomeList = response.data.validIncomeList
          if(this.validIncomeList.length == 0){
            this.validIncomeList= [0];
          }
          this.validOrderNumList = response.data.validOrderNumList
          if(this.validOrderNumList.length == 0){
            this.validOrderNumList= [0];
          }
          this.initData()
        }).catch(error => {
          console.log(error)
        })
      },
      initData: function () {
        this.chartLine = echarts.init(document.getElementById('chartLineBox'))
        // 指定图表的配置项和数据
        var option = {
          tooltip: {              //设置tip提示
            trigger: 'axis'
          },

          legend: {               //设置区分（哪条线属于什么）
            data: ['点击数', '预估订单量', '预估收入']
          },
          color: ['#3D9EFC', '#FF8622', '#FF4F76'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
          xAxis: {                //设置x轴
            type: 'category',
            boundaryGap: false,     //坐标轴两边不留白
            data: this.dayList,
            name: '',           //X轴 name
            nameTextStyle: {        //坐标轴名称的文字样式
              color: '#FA6F53',
              fontSize: 16,
              padding: [0, 0, 0, 20]
            },
            axisLine: {             //坐标轴轴线相关设置。
              lineStyle: {
                color: '#FA6F53',
              }
            }
          },
          yAxis: {
            name: '',
            nameTextStyle: {
              color: '#FA6F53',
              fontSize: 16,
              padding: [0, 0, 10, 0]
            },
            axisLine: {
              lineStyle: {
                color: '#FA6F53',
              }
            },
            type: 'value'
          },
          series: [
            {
              name: '预估订单量',
              data: this.validOrderNumList,
              type: 'line',               // 类型为折线图
              lineStyle: {                // 线条样式 => 必须使用normal属性
                normal: {
                  color: '#3D9EFC',
                }
              },
            },
            {
              name: '点击数',
              data: this.clickNumList,
              type: 'line',
              lineStyle: {
                normal: {
                  color: '#FF8622',
                }
              },
            },
            {
              name: '预估收入',
              data: this.validIncomeList,
              type: 'line',
              lineStyle: {
                normal: {
                  color: '#FF4F76',
                }
              },
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
      showDatePicker(picker) { //弹出层并显示时间选择器
        this.isPopShow = true;
        this.datePicker = picker;
      },
      cancelPicker() { // 选择器取消按钮点击事件
        this.isPopShow = false;
        this.datePicker = "";
      },
      confirmPicker(value) {// 确定按钮，时间格式化并显示在页面上
        var date = value;
        var m = date.getMonth() + 1;
        var d = date.getDate();
        if (m >= 1 && m <= 9) {
          m = "0" + m;
        }
        if (d >= 0 && d <= 9) {
          d = "0" + d;
        }
        var timer = date.getFullYear() + "-" + m + "-" + d
        if(this.datePicker == 'startTime'){
          this.searchForm.start_time = timer;
        }else{
          this.searchForm.end_time = timer;
        }
        this.isPopShow = false;
        this.datePicker = "";
      },
      formatter(type, value) {// 格式化选择器日期
        if (type === "year") {
          return `${value}年`;
        } else if (type === "month") {
          return `${value}月`;
        }
        return value;
      },
      //清除文本框
      clear(val) {
        if(val.indexOf(".") > -1){
          let varArr = val.split(".")
          this[varArr[0]][varArr[1]] = ''
        }else{
          this[val] = ''
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .search-wrap{
      overflow: hidden;
      color: #666666;
      .form-item {
        padding-top: 8px;
        overflow: hidden;
        .choose-time{
          height: 44px;
          border: 1px solid #E8E8E8;
          vertical-align: middle;
          display: flex;
          align-items: center;
          padding-left: 15px;
          padding-right: 10px;
          .time-input{
            border: none;
            outline: none;
            border-radius: 2px;
          }
          .line{
            text-align: center;
            color: #999999;
          }
        }
      }
      .form-item-tip {
        margin-right: 10px;
      }
      .search-box{
        padding: 30px 35px 0 35px;
        .search-btn {
          display: block;
          height: 35px;
          line-height: 35px;
          background: #FF8622;
          border-radius: 20px;
          color: #FFFFFF;
          font-size: 14px;
          cursor: pointer;
          text-align: center;
        }
      }

    }
    .echart-content {
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      width: 100%;
      .echart-dom {
        height: 242px;
        margin: 0 auto;
        padding: 15px 8px;
      }
      .echar-desc {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 8px;
        .detail-item {
          margin-right: 12px;
          .detail-badge {
            border-radius: 100%;
            -webkit-box-shadow: 0 0 0 1px #fff;
            box-shadow: 0 0 0 1px #fff;
            width: 8px;
            height: 8px;
            display: inline-block;
            position: relative;
            top: -1px;
            margin-right: 10px;
          }
          .detail-title {
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            padding-right: 10px;
          }
          .detail-content {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
          }
        }
      }
      .echart-info {
        padding: 8px;
        color: #999999;
        .font-15{
          font-size: 15px;
        }
      }
      .bg-orange {
        background: #ff8622;
      }
      .bg-blue {
        background: #3d9efc;
      }
      .bg-pink {
        background: #ff4f76;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/report/Index.vue